<template>
    <div class="help-content">
        <h1>Postavljanje e-računa (Fiskalizacija 2.0)</h1>
        <p>
            Fiskalizacija 2.0 se odnosi na izdavanje transakcijskih računa na kojima su kupci pravne osobe.<br />
        </p>
        <p>
            Za postavljanje e-računa i Fiskalizacije 2.0 potrebno je napraviti nekoliko koraka.<br/>
        </p>
        <ol>
            <li>Registrirati se kod posrednika za slanje e-računa <a target="_blank"
                                                                     href="https://eposlovanje.hr/">ePoslovanje</a>.
            </li>
            <li>Kopirati vrijednost polja <strong>API Key</strong> iz postavki sustava ePoslovanje u polje <strong>Token
                za slanje e-računa</strong> i odabrati posrednika u postavkama sustava Paušalko.
            </li>
            <li>
                Autorizirati posrednika u FiskAplikaciji Porezne uprave.
            </li>
            <li>Korisnicima unijeti OIB</li>
        </ol>
        <h2>Registracija u sustav ePoslovanje</h2>
        <p>
            Potrebno je izvršiti registraciju u sustav <a target="_blank" href="https://eposlovanje.hr/">ePoslovanje</a>.<br/>
            Predlažemo da se za više informacija o registraciji i naplati korištenja sustava ePoslovanje obratite direktno
            njima.
        </p>
        <h2>Kopiranje API tokena i odabir posrednika</h2>
        <p>
            U postavkama sustava ePoslovanje (<strong>Moji podaci > Za developere</strong>) potrebno je pronaći vrijednost u polju
            <strong>API Key</strong>.<br/>
            U sustavu Paušalko je potrebno otići u postavke (<strong>Postavke > Financije</strong>).<br />
            U polju <strong>Posrednik za slanje e-računa</strong> je potrebno odabrati <i>ePoslovanje</i>.<br />
            Vrijednost iz polja <strong>API Key</strong> je potrebno
            upisati u polje <strong>API token za slanje e-računa preko posrednika</strong>.<br/>
            Na kraju je potrebno kliknutu gumb <strong>Spremi</strong> koji se nalazi na vrhu.
        </p>
        <h2>Autoriziranje posrednika u FiskAplikaciji</h2>
        <p>
            U FiskAplikaciji Porezne uprave potrebno je dati dopuštenje posredniku za potpisivanje poruka prema Poreznoj upravi. Detaljnije upute za to ćete dobiti od posrednika nakon registracije.
        </p>
        <h2>Postavljanje OIB-a korisnicima</h2>
        <p>
            Iz lijevog izbornika je potrebno odabrati <strong>Postavke > Korisnici</strong>, te otvoriti korisnika kojem
            želimo postaviti OIB.<br/>
            Potrebno je unijeti korisnikov OIB u polje <strong>OIB</strong> i kliknuti na gumb <strong>Spremi</strong> koji se nalazi na vrhu.<br/>
            Postupak je potrebno ponoviti za sve korisnike koj će slati e-račune.
        </p>
        <h2>Slanje e-računa</h2>
        <p>
            Nakon što ste odradili prethodne korake u tablici s računima će se akcija za slanje e-računa pojaviti među akcijama desne strane.<br/>
            Klikom na tu ikonu otvara se prozor pomoću kojeg šaljete e-račun.
        </p>
        <div class="disclaimer">
            Samo transakcijski računi se mogu slati kao e-računi.<br/>
            Računi koji su poslani kao e-računi se ne mogu brisati i mijenjati, ali se mogu stornirati.<br/>
            Sustav ePoslovanje naplaćuje uslugu slanja e-računa.<br/>
            Troškove slanja ne snosi sustav Paušalko (obrt Modul42) nego ih snosite Vi kao korisnik sustava ePoslovanje.<br/>
            Predlažemo da se za sva pitanja oko registracije i naplate u sustavu ePoslovanje obratite direktno njima.<br />
            Budite sigurni da ste ispravno prijavili poslovne prostore Poreznoj.
        </div>
    </div>
</template>

<script>

export default {
    name: "HelpEInvoices",
    components: {},
    data() {
        return {}
    },
}
</script>

<style scoped>
.help-content {
    background: white;
}

.help-content a {
    font-weight: bold;
}

.disclaimer {
    color: red;
    font-weight: bold;
}
</style>